import { Skeleton } from 'components/ui/skeleton';
import type { HomeWidgetSize } from 'types/homeWidgets';
import { cn } from 'utils/cn';

const BLOCK = 'bg-neutral-tint';
const ROW_WIDTHS = ['w-full', 'w-[82%]', 'w-[64%]', 'w-[48%]', 'w-[30%]'];

/** What stands in for a figure that has not arrived: the shape of the card at its size, under its real header. */
export function KpiSkeleton({ size }: { size: HomeWidgetSize }) {
    if (size === '1x1') {
        return (
            <div className="flex flex-1 flex-col justify-center gap-2">
                <Skeleton className={cn(BLOCK, 'h-7 w-[132px]')} />
                <Skeleton className={cn(BLOCK, 'h-3 w-[200px] max-w-full')} />
            </div>
        );
    }
    if (size === '2x2') {
        return (
            <div className="flex min-h-0 flex-1 gap-6">
                <div className="flex w-[190px] shrink-0 flex-col gap-2.5">
                    <Skeleton className={cn(BLOCK, 'h-7 w-[150px]')} />
                    <Skeleton className={cn(BLOCK, 'h-3 w-[170px]')} />
                </div>
                <Skeleton className={cn(BLOCK, 'flex-1 rounded-lg')} />
            </div>
        );
    }
    return (
        <div className="flex min-h-0 flex-1 flex-col gap-2.5">
            <Skeleton className={cn(BLOCK, 'h-3.5 w-[120px]')} />
            <div className="flex flex-1 flex-col justify-between">
                {ROW_WIDTHS.map((width) => (
                    <Skeleton key={width} className={cn(BLOCK, 'h-[18px]', width)} />
                ))}
            </div>
        </div>
    );
}
